import { render, staticRenderFns } from "./setProduct.vue?vue&type=template&id=1877c436&scoped=true&"
import script from "./setProduct.vue?vue&type=script&lang=js&"
export * from "./setProduct.vue?vue&type=script&lang=js&"
import style0 from "./setProduct.vue?vue&type=style&index=0&id=1877c436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1877c436",
  null
  
)

export default component.exports